import React from 'react'
import CortexCredentialsForm from './CortexCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import { columnRenderArrayData } from 'utils/tableUtils';
import CortexMappingForm, { formatOSName } from './CortexMappingForm';

function CortexConfigListing(props) {

  const columns = [{
        title: "Operating System",
        dataIndex: "operatingSystem",
        width: 200,
        render: (data) => {
          return columnRenderArrayData(formatOSName(data));
        },
  }]

    return (
        <GenericPullConfigListing
          {...props}
          toolName={props.name}
          MappingForm={CortexMappingForm}
          extraColumns={columns}
          CredentialsForm={CortexCredentialsForm}
        />
      );
}

export default CortexConfigListing